import React, { Component } from 'react';
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import * as session from './services/session.js';
import { Loader } from '@simplybenefits/sb-ui-library';

class PrivateRoute extends Component {
    state = {
        loading: true,
        isAuthenticated: false
    };

    componentDidMount() {
        if (session.getToken()) {
            this.setState({
                isAuthenticated: true,
                loading: false
            });
        } else {
            this.setState({
                loading: false
            });
        }
    }

    render() {
        const { component: RouteComponent, ...rest } = this.props;

        if (this.state.loading) {
            return (
                <Loader/>
            );
        }

        return (
            <Route
                {...rest}
                render={(props) => this.state.isAuthenticated ?
                    (
                        <div id="content">
                            <RouteComponent {...props} />

                            {
                                (this.props.loader?.isLoading && this.props.loader.type === 'full') &&
                                    <Loader/>
                            }
                        </div>
                    )
                    :
                    (
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: { from: props.location }
                            }}
                        />
                    )
                }
            />
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader
});

export default (connect(mapStateToProps)(PrivateRoute));